import { render, staticRenderFns } from "./NoticeComments.vue?vue&type=template&id=de4c0e38"
import script from "./NoticeComments.vue?vue&type=script&lang=js"
export * from "./NoticeComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports